<article class="filtered-links-list">
  <div class="container-fluid">
    <div class="row filtered-links-list__background">
      <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
        <div class="filtered-links-list__headline">
          <brt-rough-headline [text]="'HOME_LINKS.HEADLINE' | translate"></brt-rough-headline>
        </div>
        <div class="filtered-links-list__text">
          {{ 'HOME_LINKS.TEXT' | translate }}
        </div>
      </div>
      <div class="col-12 filtered-links-list__toggle-button-line">
        <div class="filtered-links-list__toggle-button-wrapper">
          <button role="button" class="filtered-links-list__toggle-button" [ngClass]="{'filtered-links-list__toggle-button--active' : activeList === 'teachers'}" (click)="activeList = 'teachers'">Für Lehrpersonen</button>
          <button role="button" class="filtered-links-list__toggle-button" [ngClass]="{'filtered-links-list__toggle-button--active' : activeList === 'companies'}" (click)="activeList = 'companies'">Für Unternehmen</button>
        </div>
      </div>
      <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
        <ul class="filtered-links-list__list" *ngIf="activeList === 'teachers'">
          <li class="filtered-links-list__list-item" *ngFor="let link of teacherLinks">
            <a [href]="link.link" class="filtered-links-list__list-link" [target]="link.target">{{link.title}} <span class="icon-reg-chevron-right"></span></a>
          </li>
        </ul>
        <ul class="filtered-links-list__list" *ngIf="activeList === 'companies'">
          <li class="filtered-links-list__list-item" *ngFor="let link of companyLinks">
            <a [href]="link.link" class="filtered-links-list__list-link" [target]="link.target">{{link.title}} <span class="icon-reg-chevron-right"></span></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</article>
